import axios from "axios";
import {getXml, getXmlLocal} from "./utility";
import {hideErrorMessage, hideInternetErrorMessage, showErrorMessage} from "./main";
// import {ciao} from "./main";
// import {utility} from "./utility";

function checkUpdate(first) {
  var slidesArray = JSON.parse(window.localStorage.getItem("jsonSlides"));

  if (this.status < 1) {
    axios
      .get(
        this.API_URL +
        "/actions/PhfVideo/handshake?user=" +
        this.ID_USER +
        "&terminale=" +
        this.VIDEO_TERMINAL +
        "&versione=" +
        this.VIDEO_VERSION,
        {
          headers: {
            Authorization: this.API_TOKEN,
            // crossDomain: true,
            //
            // "Access-Control-Allow-Methods": "GET",
            // "Access-Control-Allow-Headers": "application/json"
          }
        }
      )
      .then(response => {
        this.updateAvailable = response.data.content.updataAvailable;
        if(this.debug == 1) {
          console.log("checkUpdate: response = " + this.updateAvailable)
        }
        if (response.data.content.updataAvailable == "1" || first) {
          this.updateAvailableDesc = "update available";
          this.status = 1;
        } else {
          this.updateAvailableDesc = "up to date";
          this.status = 0;
        }
        hideErrorMessage();
        hideInternetErrorMessage();
      })
      .catch(error => {
        if(this.debug == 1) {
          console.log(error);
        }
        if (slidesArray != null && slidesArray != "") {
          hideErrorMessage();
          if(this.debug == 1) {
            console.log("res status 2");
          }
          this.resetStatusOnError();
          return;
        } else {
//				alert("Download Error, check the configuration!");
//				location.href = "configurationPage.html";
          if(this.debug == 1) {
            console.log("mostro messaggio di errore 2");
          }
          showErrorMessage();
          this.status = 0;
          return;
        }
      });
  }
}

function downloadSlides(phfcli) {
  var slidesArray = JSON.parse(window.localStorage.getItem("jsonSlides"));

  if (phfcli.status == 1) {
    phfcli.status = 2;
    if(phfcli.debug == 1) {
      console.log("call the api to content download");
    }
    // var tempSlides = new Array();
    axios
      .post(
        phfcli.API_URL + "/actions/PhfVideo",
        {
          token:  phfcli.API_TOKEN,
          idUser:  phfcli.ID_USER,
          terminale:  phfcli.VIDEO_TERMINAL,
          files: []
        },
        {
          headers: {
            // crossDomain: true,
            //
            // "Access-Control-Allow-Methods": "GET",
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(response => {
//			console.log("RESPONSEFILE1");
//         var slidesTest = response;
        //prima leggo e compilo l'xml leggendo il phf video
        if (response.data.content.statusElement == null) {
          if (slidesArray != null && slidesArray != "") {
            hideErrorMessage();
            if(phfcli.debug == 1) {
              console.log("res status 3");
            }
            phfcli.resetStatusOnError();
            return;
          } else {
//					alert("Download Error, check the configuration!");
//					location.href = "configurationPage.html";
            if(phfcli.debug == 1) {
              console.log("mostro messaggio di errore 3");
            }
            showErrorMessage();
            phfcli.status = 1;
            return;
          }
        }
        hideErrorMessage();
        var responseFiles = response.data.content.files;
        var findXml = false;

        if(responseFiles.length > 0){
          for (const file of responseFiles) {
            if (file.fileName.indexOf("phfVideo.xml") != -1) {
              findXml = true;
              let urlXml = file.href + "&nomeTerminale=" +
                this.VIDEO_TERMINAL +
                "&idUser=" +
                this.ID_USER +
                "&xml=1";
              var urlXmlHttps = urlXml.replace("http", "https")
              getXml(urlXmlHttps, responseFiles, phfcli);
              break;
            }
          }
        }
        if(findXml == false){
          //Non ho scaricato phfvideo.xml rimetto stato a 0
          phfcli.resetStatusOnError();
        }
        hideErrorMessage();

      }).catch(error => {
      if(phfcli.debug == 1) {
        console.log(error);
      }
      if (error.response) {
        if (slidesArray != null && slidesArray != "") {
          hideErrorMessage();
          if(phfcli.debug == 1) {
            console.log("res status 1");
          }
          phfcli.resetStatusOnError();
          return;
        } else {
//					alert("Download Error, check the configuration!");
//					location.href = "configurationPage.html";
          if(phfcli.debug == 1) {
            console.log("mostro messaggio di errore 1");
          }
          showErrorMessage();
          this.status = 1;
          return;
        }
      }
      hideErrorMessage();
      phfcli.resetStatusOnError();
    });
  }
}
//metodo che genera url per videoxml, chiama metodo per prendere l'xml da una cartella locale
function readSlides(phfcli) {

  if (phfcli.status == 1) {
    phfcli.status = 2;
    if(phfcli.debug == 1) {
      console.log("scarico contenuti");
    }
    //indirizzo generato coi parametri presi da querystring
    var percorsoVideoXml =phfcli.appUrl + "/temp/" + phfcli.userId + phfcli.nomeUser + "_" + phfcli.palinsesto + "/4_3/";
    var videoXmlUrl = percorsoVideoXml + "phfVideo.xml?xml=1&GetFile";
    getXmlLocal(videoXmlUrl, phfcli, percorsoVideoXml);
  }
}

function downloadSlidesProxy(params) {
  params.status = 1;
}

function fetchSingleElement(elem, phfcli ) {
//	console.log("chiamo " + elem.jsonObj.href + elem.jsonObj.hash);

  var options = {
    method: 'GET',
    url: elem.jsonObj.href +
      "&nomeTerminale=" +
      phfcli.VIDEO_TERMINAL +
      "&idUser=" +
      phfcli.ID_USER +
      "&hash=" + elem.jsonObj.hash
  }
  // return fetch(
  //   elem.jsonObj.href +
  //   "&nomeTerminale=" +
  //   phfcli.VIDEO_TERMINAL +
  //   "&idUser=" +
  //   phfcli.ID_USER +
  //   "&hash=" + elem.jsonObj.hash
  //   // "&ext=test.mp4",
  // )
    return axios(options)
    .then(function (response) {
      if(phfcli.debug == 1) {
        console.log("fetch response: " + response)
      }
      elem.media = response;
    })
    .catch(function (error) {
      if(phfcli.debug == 1) {
        console.log("Looks like there was a problem: \n", error);
      }
    });
}
let newsSlideIndex = 0;
//prendo elementi da cartellina in locale, invece che scaricarli
function fetchSingleElementLocal(elem, phfcli ) {
  if (elem.jsonObj.url && elem.jsonObj.url === 'foto/news') {
    let files = elem.jsonObj.folderFiles.split("|");
    if(newsSlideIndex >= files.length) {
      newsSlideIndex = 0;
    }
    elem.jsonObj.url = "foto/news/" + files[newsSlideIndex];
    newsSlideIndex++;
  }


  //parametri presi da querystring all'avvio dell'app
  var percorsoSlide = phfcli.appUrl + "/temp/" + phfcli.userId + phfcli.nomeUser + "_" + phfcli.palinsesto + "/4_3/";
  if(phfcli.debug == 1) {
    console.log(phfcli.mode);
  }
  var options = {
    method: 'GET',
    url: percorsoSlide + elem.jsonObj.url + '?id=' + phfcli.idUnique
  }

  // return fetch(
  //   percorsoSlide + elem.jsonObj.url
  // )
    return axios(options)
    .then(function (response) {
      if(phfcli.debug == 1) {
        console.log("fetch response local: " + response)
      }
      elem.media = response;
    })
    .catch(function (error) {
      if(phfcli.debug == 1) {
        console.log("Looks like there was a problem: \n", error);
      }
    });
}


function notifyPhfUpdate() {
  axios
    .get(
      this.API_URL +
      "/actions/PhfVideo/notifyPHFupdate?user=" +
      this.ID_USER +
      "&terminale=" +
      this.VIDEO_TERMINAL,
      {
        headers: {
          Authorization: this.API_TOKEN,
          // crossDomain: true,
          // "Access-Control-Allow-Methods": "GET",
          // "Access-Control-Allow-Headers": "application/json"
        }
      }
    )
    .then(response => {
      if(this.debug == 1) {
        console.log("mandato aggiornamento" + response);
      }

    });
}

// function uploadInfo() {
//   var url = this.API_URL.replace("/api/v1","");
//   axios
//     .get(
//
//       url +
//       "/utils/uploadInfoPlayerV3.jsp?id_user=" +
//       this.ID_USER +
//       "&terminale=" +
//       this.VIDEO_TERMINAL +
//       "&versione_player=" +
//       this.version +
//       "&bacheca=0&os=Tizen",
//       {
//         headers: {
//         }
//       }
//     )
//     .then(response => {
//       hideInternetErrorMessage();
//     })
//     .catch(error => {
//       showInternetErrorMessage();
//       console.log("Errore upload info player: "+ error);
//     });
// }


export {checkUpdate, downloadSlides, downloadSlidesProxy, fetchSingleElement, notifyPhfUpdate, readSlides, fetchSingleElementLocal}

